/**
 *  @namespace core/i18n
 */
import pubSub from '~/utils/lib/core/pub-sub'
import { includes } from '~/utils/lib/core/prelude'
import { EVENTS, ERRORS } from '~/utils/lib/core/types'

export const useStore_core_i18n = defineStore('core/i18n', {
  state: () => ({
    locales: ['fr'],
    locale: '',
  }),
  actions: {
    /// Mutations
    ///
    setLocale(/** @type {string} */ locale) {
      this.locale = locale
    },
    /// Actions
    ///
    /**
     * @function setLang
     * @param {object} options
     * @param {string} options.locale
     * @promise-never-rejects
     * @return {Promise<void>}
     */
    setLang({ locale }) {
      if (!includes(locale, this.locales))
        return Promise.reject(new Error(ERRORS.UNKNOWN_LOCALE))

      this.setLocale(locale)

      pubSub.publish(EVENTS.LANG_SWITCHED, { locale })

      return Promise.resolve()
    }
  }
})
